import BlockObserver from "../components/BlockObserver";

export default class loadPost {
	constructor() {
		this.ajaxLoadMores      = document.querySelectorAll('.ajax-load-more');
		this.loadMoreButtons    = document.querySelectorAll('.btn--load-more');
		this.loadMoreForms      = document.querySelectorAll('.filter-form');

		// Run the initial load more on page load to get first page of results
		if(this.ajaxLoadMores) {
			this.ajaxLoadMores && this.ajaxLoadMores.forEach((ajaxLoadMore) => {
				let loadMoreFilters 			= ajaxLoadMore.querySelector('.filter-form');
				let loadMoreButton 				= ajaxLoadMore.querySelector('.btn--load-more');
				let loadMoreContainer			= ajaxLoadMore.querySelector('.load-more-container');
				let paginationContainer			= ajaxLoadMore.querySelector('.pagination-container');
				this.loadPosts('load-more', loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer);
			})
		}

		// If load more button is pressed
		if(this.loadMoreButtons) {
			this.loadMoreButtons && this.loadMoreButtons.forEach((loadButton) => {
				loadButton.addEventListener("click", (event) => {
					let ajaxParent 					= loadButton.closest('.ajax-load-more');
					let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
					let loadMoreButton 				= ajaxParent.querySelector('.btn--load-more');
					let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
					let paginationContainer			= ajaxParent.querySelector('.pagination-container');
					this.loadPosts('load-more', loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer);
				});
			})
		}

		// If numbered pagination is pressed
		document.body.addEventListener("click", (event) => {
			if(event.target.closest('.pagination-container button')) {
				let paginationTo             	= null;
				let currentPage                   	= document.querySelector('.current-page');
				let clickedPagination             	= event.target.closest('.pagination-container button');
				let pageButton     	= clickedPagination.getAttribute('data-pagination');

				if(pageButton === 'prev') {
					paginationTo = Number(currentPage.value) - 1;
				} else if(pageButton === 'next') {
					paginationTo = Number(currentPage.value) + 1;
				} else {
					paginationTo = pageButton;
				}

				currentPage.value = paginationTo - 1;

				let ajaxParent 					= clickedPagination.closest('.ajax-load-more');
				let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
				let loadMoreButton 				= ajaxParent.querySelector('.pagination-container');
				let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
				let paginationContainer			= ajaxParent.querySelector('.pagination-container');
				this.loadPosts('load-more', loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer);
			}
		})

		// Trigger search/filter functionality on change
		if(this.loadMoreForms) {
			this.loadMoreForms && this.loadMoreForms.forEach((loadMoreForm) => {
				this.formFilterOptions = loadMoreForm.querySelectorAll('input, select');
				this.customSelects = loadMoreForm.querySelectorAll('.dropdown__option');

				// If native input and select
				if(this.formFilterOptions) {
					this.formFilterOptions && this.formFilterOptions.forEach((formFilterOption) => {
						formFilterOption.addEventListener("change", (event) => {
							let ajaxParent 					= loadMoreForm.closest('.ajax-load-more');
							let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
							let loadMoreButton 				= ajaxParent.querySelector('.btn--load-more');
							let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
							let paginationContainer			= ajaxParent.querySelector('.pagination-container');
							this.loadPosts('filter-change', loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer);
						})
					})
				}

				// If custom select fields are present
				if(this.customSelects) {
					this.customSelects && this.customSelects.forEach((customSelect) => {
						customSelect.addEventListener("click", (event) => {
							let selectedInput = customSelect.closest('.dropdown').dataset.fieldlink;
							document.querySelector("[name="+selectedInput+"]").value = customSelect.dataset.value;

							let ajaxParent 					= loadMoreForm.closest('.ajax-load-more');
							let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
							let loadMoreButton 				= ajaxParent.querySelector('.btn--load-more');
							let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
							let paginationContainer			= ajaxParent.querySelector('.pagination-container');
							this.loadPosts('filter-change', loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer);
						})
					})
				}
			})
		}
	}

	loadPosts(loadingType, loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer) {
		this.loadMoreButton     	= loadMoreButton;
		this.loadMoreFilters		= new FormData(loadMoreFilters);
		this.loadMoreContainer  	= loadMoreContainer;
		this.paginationContainer  	= paginationContainer;

		// Disable load more button to prevent multiple clicks
		if(this.loadMoreButton) {
			this.loadMoreButton.disabled = true;
		}

		this.loadMoreFilters.append("loop", this.loadMoreContainer.getAttribute('data-type'));
		this.loadMoreFilters.append("topAfterLoad", this.loadMoreContainer.getAttribute('data-topafterload'));
		this.loadMoreFilters.append("buttonType", loadingType);

		// Get results from database table
		fetch('/wp-admin/admin-ajax.php?action=loadPosts', {
			method: 'POST',
			body: this.loadMoreFilters,
		})
		.then(response => response.json())
		.then(data => {
			// Append results to bottom of list
			if(data['results'].length) {
				// If we are loading more results into the list
				if(data['meta']['action'] === 'load-more') {
					if(data['meta']['paginationType'] === 'replace') {
						loadMoreContainer.innerHTML = "";
					}
					data['results'].forEach((result) => {
						loadMoreContainer.insertAdjacentHTML('beforeend', result);
					});
					// If we have changed the filter and loading in fresh data
				} else if(data['meta']['action'] === 'filter-change') {
					loadMoreContainer.innerHTML = "";
					data['results'].forEach((result) => {
						loadMoreContainer.insertAdjacentHTML('beforeend', result);
					});
				}
			} else {
				loadMoreContainer.innerHTML = "";
				let notFoundMessage = '<p>There are no results found</p>';
				loadMoreContainer.insertAdjacentHTML('beforeend', notFoundMessage);
			}

			// If pagination is being passed through
			if(data['pagination']) {
				paginationContainer.innerHTML = "";
				paginationContainer.insertAdjacentHTML('beforeend', data['pagination']);
			}

			// Update form data with new current page
			loadMoreFilters.querySelector('.current-page').value = data['meta']['currentPage'];

			// On success, update the load more button data attributes ready for next time around
			if(loadMoreButton) {
				const isDisabled = data['meta']['totalFound'] <= data['meta']['currentPage'] * data['meta']['perPage']
				loadMoreButton.disabled = isDisabled;

				if (isDisabled) {
					loadMoreButton.classList.add('hidden')
				} else {
					loadMoreButton.classList.remove('hidden')
				}
			}

			if(loadMoreButton && data['meta']['perPage'] === '-1') {
				document.querySelector('.load-more-button').classList.add('hidden');
			}

			if(loadMoreButton && data['meta']['currentPage'] < data['meta']['totalPages']) {
				document.querySelector('.load-more-button').style.display = 'block';
			} else {
				document.querySelector('.load-more-button').style.display = 'none';
			}

			// Update URL with filters
			let pageURL = new URL(window.location.href);
			if(this.loadMoreFilters.get('category')) {
				pageURL.searchParams.set('category', this.loadMoreFilters.get('category'));
				window.history.pushState({}, '', pageURL);
			} else {
				pageURL.searchParams.delete('category');
				window.history.pushState({}, '', pageURL);
			}

			if(data['meta']['topAfterLoad'] === 'true') {
				this.loadMoreContainer.scrollIntoView();
			}

			new BlockObserver( document.querySelectorAll('[data-watch="true"]') )

			return data;
		})
	}
}